import React from 'react'
import Transactions from 'src/app/Transactions/Transactions'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { transactionsRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const TransactionsAppRoute: AppRoute = {
  id: AppLocation.Transactions,
  routeProps: transactionsRouteProps,
  component: <Transactions />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default TransactionsAppRoute
